<template>
  <div class="editable-prop draggable draggable--bordered">
    <div class="draggable__handle"></div>

    <div class="_d-flex _p-b-2 _m-b-2 type-row">
      <a-select style="width: 120px" v-model="propertyObj.type" placeholder="Select Type">
        <a-select-option v-for="prop in availableProperties" :key="prop.value">{{ prop.label }}</a-select-option>
      </a-select>
      <a-input placeholder="Label" v-model="propertyObj.label" class="_m-l-1"></a-input>
      <a-button type="danger" @click="$emit('remove');" class="_m-l-1">Remove</a-button>
    </div>

    <div v-show="propertyObj.type" class="attributes">
      <div v-if="configType == 'schema'" class="attribute">
        <a-checkbox
          :checked="propertyObj.inBooking.isVisible"
          @change="propertyObj.inBooking.isVisible = !propertyObj.inBooking.isVisible"
        >Show value in booking-mode</a-checkbox>
        <a-checkbox
          :checked="propertyObj.inPublic.isVisible"
          @change="propertyObj.inPublic.isVisible = !propertyObj.inPublic.isVisible"
        >Show value in public</a-checkbox>
      </div>

      <div v-if="propertyObj.type == 'text'">
        <a-radio-group v-model="propertyObj.attributes.isLong" class="attribute">
          <a-radio :value="false">Short text</a-radio>
          <a-radio :value="true">Long text</a-radio>
        </a-radio-group>
      </div>
      <div v-else-if="propertyObj.type == 'select'">
        <div class="attribute">
          <a-checkbox
            :checked="propertyObj.attributes.multiple"
            @change="propertyObj.attributes.multiple = !propertyObj.attributes.multiple"
          >Allow selection of multiple values</a-checkbox>
        </div>
        <div class="attribute">
          <label class="attribute__label">Options</label>
          <a-tag
            v-for="(tag, index) in propertyObj.attributes.options"
            :key="tag"
            color="blue"
            closable
            @close="onRemoveSelectItem(index)"
            class="_m-r-1"
          >{{ tag }}</a-tag>
        </div>
        <a-input
          placeholder="Please input"
          v-model="newSelectItem"
          @keyup.enter.prevent.native="onAddSelectItem"
        ></a-input>
      </div>

      <div v-if="propertyObj.type == 'number'">
        <a-row :gutter="20">
          <a-col class="attribute" :span="12">
            <label class="attribute__label">Min</label>
            <a-input-number class="attribute__input" v-model="propertyObj.attributes.min"></a-input-number>
          </a-col>
          <a-col class="attribute" :span="12">
            <label class="attribute__label">Max</label>
            <a-input-number class="attribute__input" v-model="propertyObj.attributes.max"></a-input-number>
          </a-col>
        </a-row>
      </div>

      <div v-if="propertyObj.type == 'datasource'">
        <div class="attribute">
          <a-checkbox
            :checked="propertyObj.attributes.allowCreate"
            @change="propertyObj.attributes.allowCreate = !propertyObj.attributes.allowCreate"
          >Allow creating items when booking</a-checkbox>
        </div>
        <div class="attribute">
          <a-checkbox
            :checked="propertyObj.attributes.allowEdit"
            @change="propertyObj.attributes.allowEdit = !propertyObj.attributes.allowEdit"
          >Allow editing items when booking</a-checkbox>
        </div>

        <div class="attribute">
          <label class="attribute__label">Datasource</label>
          <a-select
            v-model="propertyObj.attributes.datasourceId"
            placeholder="Select Datasource"
            class="attribute__input"
          >
            <a-select-option
              v-for="datasource in datasourcesExcludingCurrent"
              :key="datasource.id"
            >{{datasource.name}}</a-select-option>
          </a-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import availableProperties from "@/config/properties.js";
import { mapGetters } from "vuex";

export default {
  props: {
    property: {
      type: Object
    },
    index: {
      type: null
    },
    configType: {
      type: String
    }
  },
  data() {
    return {
      availableProperties: availableProperties,
      propertyObj: this.property,
      newSelectItem: null
    };
  },
  watch: {
    "propertyObj.type": function(type) {
      this.availableProperties[type].attributes.forEach(v => {
        this.$set(this.propertyObj.attributes, v.name, v.value);
      });
    }
  },
  computed: {
    ...mapGetters("datasource", {
      allDatasources: "asArray"
    }),
    datasourcesExcludingCurrent() {
      if (this.$route.name == "datasource-edit" && this.$route.params.id) {
        return this.allDatasources.filter(d => d.id != this.$route.params.id);
      } else {
        return this.allDatasources;
      }
    }
  },
  methods: {
    onAddSelectItem() {
      this.propertyObj.attributes.options.push(this.newSelectItem);
      this.newSelectItem = "";
    },
    onRemoveSelectItem(index) {
      this.propertyObj.attributes.options.splice(index, 1);
    }
  },
  created() {
    if (!this.propertyObj.inBooking) {
      this.$set(this.propertyObj, "inBooking", {
        isVisible: false,
        componentType: null
      });
    }
    if (!this.propertyObj.inPublic) {
      this.$set(this.propertyObj, "inPublic", {
        isVisible: false,
        componentType: null
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.attribute {
  margin-bottom: $--size-1;

  &__label {
    display: block;
    margin-bottom: $--size-1;
    margin-top: $--size-2;
  }

  &__input {
    width: 100%;
  }
}

.type-row {
  border-bottom: 1px solid $color-base-border;
}
</style>
